export default {
  navRooms: 'Zimmer',
  navAusflugsziele: 'Ausflugsziele',
  navLocation: 'Lage & Umgebung',
  navHotel: 'Das Hotel',
  navContact: 'Kontakt & Anreise',
  navBook: 'Buchen',
  hotelName: 'Hotel Alpenhof',
  langSwitch: 'EN',
  sliderPrev: 'Vorheriges Bild',
  sliderNext: 'Nächstes Bild',
  close: 'Schließen',
};
